"use client";
import { useState } from "react";
import ErrorComponent from "@/components/empty/ErrorComponent";
import { SelectField } from "@/components/formation";
import { GetHeadToHeadBetSuccessQuery } from "@/graphql/gql/graphql";
import { BetSuccessEvent } from "../../types";
import PlayerPropResult from "./playerPropResult";
import styles from "./betSuccessClient.module.scss";

export type PlayerPropsOddsResult = NonNullable<
  BetSuccessEvent["playerPropOddsResult"]
>;

type OddsKeys = Exclude<keyof PlayerPropsOddsResult, "__typename">;

enum PropBetSelection {
  ANYTIME_TDS = "AnytimeTDs",
  PASSING = "Passing",
  RECEIVING = "Receiving",
  RUSHING = "Rushing",
}

const SELECTION_TO_ODDS_KEY: Record<PropBetSelection, OddsKeys> = {
  [PropBetSelection.ANYTIME_TDS]: "anytimeTDs",
  [PropBetSelection.PASSING]: "overPassingYards",
  [PropBetSelection.RECEIVING]: "overReceivingYards",
  [PropBetSelection.RUSHING]: "overRushingYards",
};

const SELECTION_OPTIONS = [
  { label: "Anytime Touchdowns", value: PropBetSelection.ANYTIME_TDS },
  { label: "Passing Yards", value: PropBetSelection.PASSING },
  { label: "Receiving Yards", value: PropBetSelection.RECEIVING },
  { label: "Rushing Yards", value: PropBetSelection.RUSHING },
];

type BetSuccessClientProps = {
  data: GetHeadToHeadBetSuccessQuery;
};

const BetSuccessClient = ({ data }: BetSuccessClientProps) => {
  const [selected, setSelected] = useState(PropBetSelection.ANYTIME_TDS);
  const oddsKey = SELECTION_TO_ODDS_KEY[selected];
  const MAX_RESULTS = 6;
  const oddsData = data.event?.playerPropOddsResult?.[oddsKey] ?? [];
  const trimmedOddsData = oddsData.slice(0, MAX_RESULTS);

  return (
    <div className={styles.container}>
      <SelectField
        id="player-prop-result-selection"
        isCondensed
        label="Type"
        css={{ flex: 1, marginBottom: 8 }}
        onValueChange={(value) => setSelected(value as PropBetSelection)}
        options={SELECTION_OPTIONS}
      />
      {trimmedOddsData.length === 0 ? (
        <div className={styles.noResults}>
          <ErrorComponent
            headline="Aaand... no good!"
            subtext="No content available. Please check back later."
            showCta={false}
          />
        </div>
      ) : (
        <div className={styles.results}>
          {trimmedOddsData.map((odds) => (
            <PlayerPropResult
              key={`${oddsKey}-${odds?.player?.name}`}
              odds={odds}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default BetSuccessClient;
